<template>
    <div>
        <div class="columns is-mobile px-3">
            <div class="column px-0">
                <div class="file is-fullwidth is-primary">
                    <label v-if="!uploading" class="">
                        <input
                            class="file-input is-clickable"
                            type="file"
                            accept="image/*"
                            multiple="false"
                            @input="handleImage"
                        />
                        <div :style="getBackground"></div>
                    </label>
                    <a v-else class="button is-ghost is-fullwidth is-loading" />
                </div>
            </div>
           
        </div>
    </div>
</template>

<script>
import { upload } from '@/services/API';
export default {
    props: {
        /*image: {
            type: Object,
            default: () => {
                return {};
            },
        },*/
        image: {
            type: String,
            default: ""
        },
        canEdit: { type: Boolean, default: false },
    },
    data() {
        return {
            uploading: false,
        };
    },
    computed: {
        getBackground() {
            if (this.image) {
                return `background-image:url(${this.image});background-size:cover; background-repeat: no-repeat; background-position: center;height: 128px;border-radius: 50%;width: 128px; border-width:1px; border-color: #9f9f9f; border-style:solid; background-color: #f9f9f9;`;
            }
            return `background-image:url('${this.defaultImage}');background-size:cover; background-repeat: no-repeat; background-position: center;height: 128px;border-radius: 50%;width: 128px;border-width:1px; border-color: #9f9f9f; border-style:solid; background-color: #f9f9f9;`;
        },
        defaultImage(){
            return "/img/usuari.png";
        },
    },
    methods: {
        async handleImage(ev) {
            if (!ev.target.files) {
                // console.log('no files!');
                return;
            }
            var fr = new FileReader();
            fr.onload = () => {
                this.localImage = fr.result;
            };
            fr.readAsDataURL(ev.target.files[0]);
            this.uploading = true;
            let response = await upload(`image`, ev.target.files).catch(
                (err) => {
                    alert(this.$t(`Error.${err}`));
                    this.deleteImage();
                    return this.$emit('error');
                }
            );
            this.uploading = false;
            if (response.data) {
                //this.omage = response.data.image[0].url;
                this.$emit('update:image', response.data.image[0].url);
            }
        },
        deleteImage() {
            this.localImage = null;
            this.$emit('update:image', undefined);
        },
    },
};
</script>

<style scoped>
/*.image.is-5by3 {
    border: 2px solid #f4f4f4;
    border-radius: 4px;
    border-bottom: none;
}*/
img {
    object-fit: cover;
}
.delete {
    margin-bottom: 5px !important;
}

.file.is-fullwidth {
    display: block;
}
.file-cta {
    display: block;
    text-align: center;
}
.file-label {
    display: block;
    line-height: 1.9rem;
}
</style>
